import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bone">
        <div className="flex items-center gap-3 text-aubergine/60">
          <div className="h-2 w-2 rounded-full bg-champagne animate-pulse" />
          <span className="font-mono text-xs uppercase tracking-widest">Loading</span>
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
